import { render } from "./PromocodeBlock.vue?vue&type=template&id=72e9451e&scoped=true"
import script from "./PromocodeBlock.vue?vue&type=script&lang=js"
export * from "./PromocodeBlock.vue?vue&type=script&lang=js"

import "./PromocodeBlock.vue?vue&type=style&index=0&id=72e9451e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e9451e"]])

export default __exports__